import React from "react";
import { Link } from "react-router-dom";
import "./PandCard.css";

const PandCard = (props) => {
  return (
    <div className="card">
      <div className="card-image">
        <figure className="image is-4by3">
          <img src={props.afbeeldingURL} alt="Pand afbeelding" />
        </figure>
      </div>
      <div className="card-content" style={{ height: "12rem" }}>
        <div className="media">
          <div className="media-content">
            <p className="title is-4">{props.pandnaam}</p>
            <p className="subtitle is-6">{props.adres}</p>
          </div>
        </div>
      </div>

      <footer className="card-footer">
        <Link to={`/panden/${props.pandId}`} className="card-footer-item">
          <i className="fas fa-info-circle"></i>
          Meer informatie
        </Link>
      </footer>
    </div>
  );
};

export default PandCard;
